/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { createContext, useState } from 'react';
import { IEuiSummary } from '../../components/DashboardKPIWidgets/IEnergyManagementProps';

export interface IPollingContext {
  lastPollingTime: string;
  euiSummary: IEuiSummary;
  setPollingTime: () => void;
  setEuiSummary: (eui: IEuiSummary) => void;
}

const PollingContext = createContext<IPollingContext>({} as IPollingContext);

const PollingContextProvider: React.FC<{}> = ({ children }) => {
  const [lastPollingTime, setLastPollingTime] = useState(
    new Date().toISOString()
  );
  const [euiSummaryState, setEuiSummaryState] = useState({} as IEuiSummary);
  return (
    <PollingContext.Provider
      value={{
        lastPollingTime: lastPollingTime,
        euiSummary: euiSummaryState,
        setPollingTime: () => setLastPollingTime(new Date().toISOString()),
        setEuiSummary: (_euiSummary: IEuiSummary) =>
          setEuiSummaryState(_euiSummary)
      }}
    >
      {children}
    </PollingContext.Provider>
  );
};

export { PollingContext, PollingContextProvider };
